// @ts-nocheck
import { get } from 'lodash'
import { FormFieldLayout } from '../../generic'

export default function NoEditTextField({
  errors,
  formKey,
  keys,
  inputType,
  onChange,
  className,
  placeholder,
  formatValue,
  style,
  values,
  ...props
}) {
  const value =
    keys && keys.length
      ? `${get(values, keys[0])} ${get(values, keys[1])}`
      : get(values, formKey)

  return (
    <FormFieldLayout {...props}>
      <div style={{ ...style, ...styles.wrapper }}>
        {formatValue ? formatValue(value) : value}
      </div>
    </FormFieldLayout>
  )
}

const styles = {
  wrapper: {
    padding: '9px 10px',
    borderRadius: 5,
    minHeight: 37,
    background: '#f0efe1',
  },
}
